export default __webpack_public_path__ + "static/media/PurpleLabHouseholdId.f053d90f.csv";